import React from 'react';
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Blog from "../../components/blogFooter/blogFooter";
import FunctionResident from "../../components/functionResident/functionResident";
import HeaderForBoard from "../../components/header/forBoard/headerForBoard";
import Image from "../../components/image";
import { asset } from '../../helpers/dom.helper';
import i18n from "../../i18n";
import './style.scss';

import { Media, MediaContextProvider } from "../../media";
import Guarantee from "../../pages/Home/guaranteeHome";
import RegisterHome from "../../pages/Home/registerHome";

function ForBoard(props) {

  const { t } = useTranslation(['translation', 'forBoard'])

  return (
    <>
      <Helmet>
        <title>{t("forBoard:title")}</title>
        <meta name="description" content={t("forBoard:metaDescription")} />
        <meta name="keywords" content={t("forBoard:metaKeyWord")} />
        <link rel="canonical" href="https://silverman.app/for-board" />
        <style>{`
          :root {
            --page-header-bg-desktop: url(${asset('/images/home/header-bg-desktop.webp')});
            --page-header-bg-mobile: url(${asset('/images/home/header-bg-mobile.webp')});
          }
        `}</style>
      </Helmet>
      
      {/* <ScrollToTopOnMount /> */}
      <HeaderForBoard {...props} />

      <div className="for-board">
        <div className="box">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6 d-none d-md-block text-center">
                <Image src={asset('/images/forBoard/trace.webp')}
                  alt="trace" className="img-fluid mb-2" />
              </div>
              <div className="col-md-6 text-left">
                <h1>{t("forBoard:Keep an eye on accounting activities.")}</h1>
                <p>{t("forBoard:Silverman offers an ultimate feature designed specially for committees.")}</p>
              </div>
              <div className="col-md-6 d-md-none">
                <Image src={asset('/images/forBoard/trace.webp')}
                  alt="trace" className="img-fluid mb-2" />
              </div>
            </div>
          </div>
        </div>

        <div className="box">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6 text-left">
                <h1>{t("forBoard:The answer to debt problems")}</h1>
                <p>{t("forBoard:Committee members can see the list of residents in debt on common area fees or other purchases.")}</p>
              </div>
              <div className="col-md-6 text-center">
                <Image src={asset('/images/forBoard/receipt.webp')}
                  alt="receipt" className="img-fluid mb-2" />
              </div>
            </div>
          </div>
        </div>

        <div className="box">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6 d-none d-md-block text-center">
                <Image src={asset('/images/forBoard/real-time.webp')}
                  alt="real-time" className="img-fluid mb-2" />
              </div>
              <div className="col-md-6 text-left">
                <h1>{t("forBoard:Update financial status in real time")}</h1>
                <p>{t("forBoard:On Silverman platform, committees always get actionable intelligence from reports;")}</p>
              </div>
              <div className="col-md-6 d-md-none">
                <Image src={asset('/images/forBoard/real-time.webp')}
                  alt="real-time" className="img-fluid mb-2" />
              </div>
            </div>
          </div>
        </div>

        <div className="box">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6 text-left">
                <h1>{t("forBoard:Urgency made easy by Silverman")}</h1>
                <p>{t("forBoard:In event that requires immediate action, " +
                  "committee members will be notified and be able to respond")}</p>
              </div>
              <div className="col-md-6 text-center">
                <Image src={asset('/images/forBoard/quick.webp')}
                  alt="receipt" className="img-fluid mb-2" />
              </div>
            </div>
          </div>
        </div>

        <div className="box">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6 d-none d-md-block text-center">
                <Image
                  src={asset('/images/forBoard/fix-complaint.webp')}
                  alt="fix-complaint.webp" className="img-fluid mb-2" />
              </div>
              <div className="col-md-6 text-left">
                <h1>{t("forBoard:Maintenance/Complaint Management")}</h1>
                <p>{t("forBoard:Via online summary reports, committee members can keep " +
                  "track of all maintenance requests and complaints.")}</p>
              </div>
              <div className="col-md-6 d-md-none">
                <Image
                  src={asset('/images/forBoard/fix-complaint.webp')}
                  alt="fix-complaint.webp" className="img-fluid mb-2" />
              </div>
            </div>
          </div>
        </div>

        <div className="box">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6 text-left">
                <h1>{t("forBoard:Secure and up to date")}</h1>
                <p>{t("forBoard:Residential information is crucial for smooth management " +
                  "in every property.")}</p>
              </div>
              <div className="col-md-6 text-center">
                <Image src={asset('/images/forBoard/update.webp')}
                  alt="receipt" className="img-fluid mb-2" />
              </div>
            </div>
          </div>
        </div>

        <div className="box">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6 d-none d-md-block text-center">
                <Image
                  src={asset('/images/forBoard/EVote.webp')}
                  alt="EVote.webp" className="img-fluid mb-2" />
              </div>
              <div className="col-md-6 text-left">
                <h1>{t("foQus:E-Meetings and E-Vote")}</h1>
                <p>{t("foQus:With Silverman technology that supports online meetings and electronic voting (E-Vote)")}</p>
                <Link to={(i18n.language !== "th" ? "/" + i18n.language : "") + "/foQus"} >
                  <span className="read-more">{t("Read More")}</span>
                </Link>
              </div>
              <div className="col-md-6 d-md-none">
                <Image
                  src={asset('/images/forBoard/EVote.webp')}
                  alt="EVote.webp" className="img-fluid mb-2" />
              </div>
            </div>
          </div>
        </div>

        <FunctionResident />

        <div className="row">
          <div className="col-3"></div>
          <div className="col-6 text-center">
            <div className="register">
              <MediaContextProvider>
                <Media greaterThanOrEqual="md">
                    <RegisterHome />
                </Media>
              </MediaContextProvider>
            </div>
          </div>
          <div className="col-3"></div>
        </div>

        <div className="guarantee text-center">
          <br></br><br></br>  <br></br><br></br>

          <Guarantee />
        </div> 

        <Blog />
      </div>
    </>
  )
}

export default ForBoard;